// ToDo
// Consider bigger font/items on the list
// Consider easier delete functionality
// Improve button style and add hover effect
// Add character limit for description
// Build an API
// Consider different signup/user authentication functionality
// Exchange refresh token for a new token, whenever the current token expires
// Check if 'userId' is ever actually being used and remove if not

import Vue from "vue";
import "./plugins/fontawesome";
import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
